import React from "react";
import Slider from "react-slick";

const PromoOffers = () => {
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => ('');
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => ('');

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 2,
    nextArrow: <SlickArrowRight />,
    prevArrow: <SlickArrowLeft />,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 2 }
      }
    ],
  };

  const offers = [
    { label: "Double Your Deposit", link: "/promos" },
    { label: "$150 Starter Pack", link: "/promos" },
    { label: "Tap-In Tuesdays", link: "/promos" },
    { label: "Fire-up Fridays", link: "/promos" }
  ];

  // If ?promo=free is in the URL, add a free offer
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('promo') === 'free') {
    offers.unshift({ label: "$5 Free", link: "/promos" });
  }
  if (urlParams.get('promo') === '5x') {
    offers.unshift({ label: "Play $5, Get $25", link: "/promos" });
  }
  if (urlParams.get('promo') === '3x') {
    offers.unshift({ label: "3X First Deposit", link: "/promos" });
  }
  if (urlParams.get('promo') === '75') {
    offers.unshift({ label: "Play $5, Get $75*", link: "/promos" });
  }

  return (
    <div className="mt-3">
      <Slider {...settings}>
        {offers.map((offer, idx) => (
          <a
            key={idx}
            href={offer.link}
            className="select-btn"
          >
            {offer.label}
          </a>
        ))}
      </Slider>
    </div>
  );
};

export default PromoOffers;
